import axios from "axios";
import { SERVICE_URL } from "common/Constants";

export const apiInstance = axios.create({
  baseURL: SERVICE_URL,
});
